<template>
  <article
    class="message isso-message"
    :class="messageClass"
  >
    <div class="message-body">
      <div class="information level is-marginless">
        <span class="label level-left">{{ authorName(author) }}</span>
        <span class="level-right">
          {{ timeFromNow(created) }}
        </span>
      </div>
      <div class="text">
        <p>
          {{ showtext(text) }}
        </p>
      </div>
    </div>
  </article>
</template>
<script>
import moment from 'moment';

export default {
  name: 'IssoComment',
  props: {
    id: { type: Number, default: 0 },
    author: { type: String, default: '' },
    website: { type: String, default: '' },
    created: { type: Number, default: 0 },
    text: { type: String, default: '' },
    thread: { type: String, default: '' },
  },
  data() {
    return {
      replyshow: false,
      editshow: false,
      editError: null,
      now: new Date(),
      messageClass: {
        'class-sender': (this.authorName(this.author) === 'Yo'),
        'class-receiver': false,
      },
    };
  },
  mounted() {
    setInterval(this.currentTime, 1000);
  },
  methods: {
    showtext(text) {
      return text.replace(/<\/?[^>]+(>|$)/g, '');
    },
    timeFromNow(time) {
      moment.lang('ES');
      const published = new Date(new Date(0).setUTCSeconds(time));
      return moment(published).fromNow();
    },
    authorName(author) {
      if (this.$route.name !== 'StatusAccountDetail') {
        if (this.$store.state.company.name === author) {
          author = 'Yo';
        }
      } else if (this.$store.state.customers.temporal.name === author) {
        author = 'Yo';
      }
      return author;
    },

  },

};
</script>
<style scoped>
  .message {
    background-color: #EEF3FC;
    width:50%;
  }
  .message-body {
    height: auto;;
  }
  .level-left {
    word-break: break-word;
    flex-basis: 50%;
  }
  .level-right {
    word-break: break-word;
    flex-basis: 50%;
  }

  .class-sender {
    align-self: flex-end;
    background-color: #EFFAF3;
    width:50%;
    height:auto;
  }
</style>
